import React from 'react';
import './CSS/Vision.css';

// Import images and icons
import visionImage from '../assets/images/vision.png';
import tickIcon from '../assets/icons/tick.png';

const Vision = () => {
  const visionPoints = [
    "Giving people confidence through clear, dependable solutions.",
    "Combining diverse services under one trusted name.",
    "Building lasting relationships within the neighborhoods.",
    "Continuously evolving to meet modern-day needs."
  ];

  return (
    <section className="vision-section">
      <div className="container">
        <div className="vision-content">
          {/* Left Column - Image */}
          <div className="vision-left">
            <div className="vision-image">
              <img src={visionImage} alt="Our Vision" />
            </div>
          </div>

          {/* Right Column - Content */}
          <div className="vision-right">
            <div className="vision-text-content">
              <h2 className="vision-title">
                Our <span className="text-primary">Vision</span>
              </h2>
              <p className="vision-description">
                To become London's most trusted multi-service brand — where anyone can walk in with a problem and walk out with a solution. We're building a future where convenience, trust, and quality go hand in hand — across tech, lifestyle, and support services.
              </p>
              <ul className="vision-list">
                {visionPoints.map((point, index) => (
                  <li key={index} className="vision-list-item">
                    <img src={tickIcon} alt="tick" className="vision-tick" />
                    <span className="vision-point-text">{point}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Vision;